import { render, staticRenderFns } from "./ProcessesMetricsTable.vue?vue&type=template&id=79f644c9&scoped=true"
import script from "./ProcessesMetricsTable.ts?vue&type=script&lang=ts&external"
export * from "./ProcessesMetricsTable.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79f644c9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src120839944/src/sctd-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('79f644c9')) {
      api.createRecord('79f644c9', component.options)
    } else {
      api.reload('79f644c9', component.options)
    }
    module.hot.accept("./ProcessesMetricsTable.vue?vue&type=template&id=79f644c9&scoped=true", function () {
      api.rerender('79f644c9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Modules/Dashboard/components/ProcessesTableSection/ProcessesMetricsTable/ProcessesMetricsTable.vue"
export default component.exports